import React, { useContext, useEffect, useState } from "react";
import { icons } from "../../../constants";
import { Link } from "react-router-dom";
import "../../TableHeader/styles/styles.css";
import { TranslationsContext } from "../../../utils/TranslationsContext";
import ExpandableText from "./ExpandableText";
import Suggestions from "./Suggestions";
import CountryFlag from "./CountryFlag";
import { useTheme } from "../../../utils/ThemeContext";
import ChildrenRow from "./ChildrenRow";
import { useNavigate } from "react-router-dom";
import IconWithTooltip from "../../IconWithTooltip/IconWithTooltip";
import AvatarThumb from "../../AvatarThumb/AvatarThumb";
import { formatDate, timeString } from "../../../utils/formatDate";

const TableRow = ({
  rowData,
  totalWidth,
  onClick,
  onDownloadClick,
  onCheckboxClick,
  seeAllColumns,
  forUsers,
  isLoadingData,
  isPlaceholder,
  onActionClick,
  isLast,
  query,
  onDeleteClick,
  showSaveButton,
  verifiers,
  onStatusClick,
  onNameClick,
  onAddSubgroupClick,
  onSendMail,
  onGenerateAccr,
  onSendInvite,
}) => {
  const { t } = useContext(TranslationsContext);
  const { theme } = useTheme();
  const [showChildren, setShowChildren] = useState(false);
  const navigate = useNavigate();

  let status = "";
  if (rowData.status) {
    switch (rowData.status.toLowerCase()) {
      case "odobren":
        status = t("APPROVED");
        break;
      case "odbijen":
        status = t("REJECTED");
        break;
      case "u_obradi":
        status = t("PROCESSING");
        break;
      case "nov":
        status = t("NEW");
        break;
      default:
        status = t("NEW");
        break;
    }
  }

  let suggestions = [];
  let counters = {
    approved: 0,
    rejected: 0,
  };

  if (Array.isArray(rowData.predlozi)) {
    suggestions = rowData.predlozi
      .map((p) => {
        const status = p.status?.toLowerCase();
        switch (status) {
          case "odobren":
            counters.approved++;
            return t("APPROVED");
          case "odbijen":
            counters.rejected++;
            return t("REJECTED");
          default:
            return null;
        }
      })
      .filter(Boolean);
  }

  return (
    <React.Fragment>
      <div
        className={`flex-direction-row items-center width-100 relative table-row ${
          isLast ? "last-row" : ""
        } ${forUsers ? "for-users" : ""} ${
          rowData.RowClassName
            ? rowData.RowClassName
            : showSaveButton
              ? "border-left-transparent"
              : ""
        } ${forUsers && !rowData.checkbox ? "checkbox-false" : ""}`}
        onClick={(e) => {
          console.log("class", rowData.className, rowData);

          const linkElement =
            e.target.tagName === "A" ? e.target : e.target.closest("a");
          if (linkElement) {
            return;
          }

          if (
            rowData.className === "user" ||
            rowData.className === "group" ||
            rowData.className === "template"
          ) {
            e.stopPropagation();
            onClick(rowData.id);
          } else if (rowData.className === "event") {
            e.stopPropagation();
            navigate(`/event/${rowData.slug || rowData.id}`);
          } else if (rowData.className === "registered-user") {
            e.stopPropagation();
            onActionClick(rowData.id);
          } else if (
            rowData.className === "event-groups-table" ||
            rowData.className === "event-users-table"
          ) {
            e.stopPropagation();
            onNameClick(rowData.id);
          }
        }}
      >
        {Object.entries(rowData)?.map(([key, value]) => {
          if (
            key === "width" ||
            key === "id" ||
            key === "slug" ||
            key === "className" ||
            key === "RowClassName" ||
            key === "unreadKomentariCount" ||
            key === "drzavljanstvoFlag" ||
            key === "pozicijaSub" ||
            key === "missingTemplate" ||
            key === "dogadjajGrupaKorisnikId" ||
            key === "akrEmailSentAt" ||
            key === "invitationSentAt" ||
            key?.toLowerCase() === "children"
          )
            return null;

          let columnWidth =
            (isPlaceholder
              ? value.width / totalWidth
              : rowData.width[key.toLowerCase()] / totalWidth) * 100;

          return (
            <React.Fragment key={key}>
              {isPlaceholder ? (
                <div
                  className={`animated-bg-text animated-bg placeholder-cell ${
                    seeAllColumns ? "" : "hide"
                  } ${value.className}`}
                  style={{
                    height: "20px",
                    margin: "0 6px",
                    minWidth: "108px",
                    width: `${columnWidth}%`,
                  }}
                ></div>
              ) : (
                <div
                  key={key}
                  style={{ width: `${columnWidth}%` }}
                  className={`relative flex-direction-row items-center table-cell  ${
                    rowData.className ? rowData.className : ""
                  } ${key === "status" ? `${key} ${value}` : key} ${
                    seeAllColumns ? "" : "hide"
                  } ${forUsers ? "for-users" : ""}`}
                >
                  {rowData.className === "event" && key === "naziv" ? (
                    <ExpandableText
                      text={String(value)}
                      isLoadingData={isLoadingData}
                      isPlaceholder={isPlaceholder}
                      type={"link"}
                      to={`/event/${rowData.slug || rowData.id}`}
                      className={rowData.className + " " + key}
                      query={query}
                    />
                  ) : (key === "actions" ||
                      key === "actions_2" ||
                      key === "actions_3") &&
                    rowData.className !== "first-registered-user" ? (
                    <div className="flex-direction-row gap-4 items-center">
                      {rowData.className === "event-groups-table" &&
                        rowData.missingTemplate && (
                          <IconWithTooltip
                            tooltip={t("GROUP_MISSING_DESIGN_TEMPLATE_TOP")}
                          >
                            <img
                              alt="warning"
                              src={icons.warning}
                              width={26}
                              height={26}
                            />
                          </IconWithTooltip>
                        )}
                      {rowData.className !== "user" && (
                        <IconWithTooltip tooltip={t("EDIT")}>
                          <img
                            className="pointer"
                            alt="edit"
                            src={theme === "light" ? icons.pen : icons.pen_dark}
                            width={26}
                            height={26}
                            onClick={(e) => {
                              e.stopPropagation();
                              onClick(rowData.id);
                            }}
                          />
                        </IconWithTooltip>
                      )}
                      {key === "actions" &&
                        rowData.className !== "registered-user" && (
                          <IconWithTooltip tooltip={t("DELETE")}>
                            <img
                              className="pointer"
                              alt="delete"
                              src={
                                theme === "light"
                                  ? icons.trash_bin
                                  : icons.trash_bin_dark
                              }
                              width={24}
                              height={24}
                              onClick={(e) => {
                                e.stopPropagation();
                                onDeleteClick(rowData.id);
                              }}
                            />
                          </IconWithTooltip>
                        )}
                      {key === "actions_2" &&
                        rowData.className === "event-users-table" && (
                          <IconWithTooltip
                            tooltip={
                              rowData.invitationSentAt
                                ? `${t("ALREADY_SENT_ON")}: ${formatDate(
                                    rowData.invitationSentAt,
                                  )} ${timeString(rowData.invitationSentAt)}`
                                : t("SEND_INVITATION")
                            }
                          >
                            <div className="relative send-icon-wrapper">
                              <img
                                className="pointer"
                                alt="invite"
                                src={icons.at_icon}
                                width={26}
                                height={26}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  onSendInvite(rowData.dogadjajGrupaKorisnikId);
                                }}
                              />
                              {rowData.invitationSentAt && (
                                <span className="send-icon-sent-dot" />
                              )}
                            </div>
                          </IconWithTooltip>
                        )}
                      {key === "actions_2" && (
                        <IconWithTooltip tooltip={t("REMOVE")}>
                          <img
                            className="pointer"
                            alt="remove"
                            src={
                              theme === "light"
                                ? icons.remove
                                : icons.remove_dark
                            }
                            width={26}
                            height={26}
                            onClick={(e) => {
                              e.stopPropagation();
                              onDeleteClick(rowData.id);
                            }}
                          />
                        </IconWithTooltip>
                      )}
                      {key === "actions_3" && (
                        <IconWithTooltip tooltip={t("ADD")}>
                          <img
                            className="pointer"
                            alt="add"
                            src={
                              theme === "light"
                                ? icons.add_blue
                                : icons.add_blue_dark
                            }
                            width={26}
                            height={26}
                            onClick={(e) => {
                              e.stopPropagation();
                              onAddSubgroupClick(rowData.id);
                            }}
                          />
                        </IconWithTooltip>
                      )}
                    </div>
                  ) : key === "actions" &&
                    rowData.className === "first-registered-user" ? (
                    <IconWithTooltip tooltip={t("ACTION") || t("VIEW")}>
                      <Link
                        // to={`/person/${rowData.id}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          onActionClick(rowData.id);
                        }}
                        className="inria-sans-400 font-14 pointer"
                      >
                        <img
                          className="pointer"
                          alt="action"
                          src={icons.action}
                        />
                      </Link>
                    </IconWithTooltip>
                  ) : key === "ime" &&
                    rowData.className === "registered-user" ? (
                    <ExpandableText
                      text={String(value)}
                      isLoadingData={isLoadingData}
                      isPlaceholder={isPlaceholder}
                      className={rowData.className + " " + key}
                      query={query}
                      onClick={(e) => {
                        e.stopPropagation();
                        onActionClick(rowData.id);
                      }}
                    />
                  ) : (key === "celo_ime" && rowData.className === "user") ||
                    (key === "naziv" && rowData.className === "group") ? (
                    <ExpandableText
                      text={key !== "status" ? String(value) : String(status)}
                      isLoadingData={isLoadingData}
                      isPlaceholder={isPlaceholder}
                      className={rowData.className + " " + key}
                      query={query}
                      status={key === "status"}
                      onClick={(e) => {
                        e.stopPropagation();
                        onClick(rowData.id);
                      }}
                    />
                  ) : key === "accreditation" ? (
                    <React.Fragment>
                      {rowData.status === "odobren" && (
                        <React.Fragment>
                          {rowData.accreditation ? (
                            <div className="flex-direction-row">
                              <IconWithTooltip
                                tooltip={
                                  rowData.akrEmailSentAt
                                    ? `${t("ALREADY_SENT_ON")}: ${formatDate(
                                        rowData.akrEmailSentAt,
                                      )} ${timeString(rowData.akrEmailSentAt)}`
                                    : t("SEND")
                                }
                              >
                                <div className="relative send-icon-wrapper">
                                  <img
                                    className="pointer"
                                    alt="send"
                                    width={28}
                                    height={28}
                                    src={
                                      theme == "light"
                                        ? icons.at_icon
                                        : icons.at_icon
                                    }
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      onSendMail(rowData.id);
                                    }}
                                  />
                                  {rowData.akrEmailSentAt && (
                                    <span className="send-icon-sent-dot" />
                                  )}
                                </div>
                              </IconWithTooltip>
                              <IconWithTooltip tooltip={t("DOWNLOAD")}>
                                <img
                                  className="pointer"
                                  alt="download"
                                  width={28}
                                  height={28}
                                  src={
                                    theme == "light"
                                      ? icons.download
                                      : icons.download_dark
                                  }
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    onDownloadClick(rowData.id);
                                  }}
                                />
                              </IconWithTooltip>
                            </div>
                          ) : (
                            <IconWithTooltip tooltip={t("GENERATE")}>
                              <img
                                className="pointer"
                                alt="generate"
                                width={28}
                                height={28}
                                src={
                                  theme == "light"
                                    ? icons.generate_accr
                                    : icons.generate_accr_dark
                                }
                                onClick={(e) => {
                                  e.stopPropagation();
                                  onGenerateAccr(rowData.id);
                                }}
                              />
                            </IconWithTooltip>
                          )}
                        </React.Fragment>
                      )}
                    </React.Fragment>
                  ) : key === "slika_avatar" ? (
                    <AvatarThumb id={rowData.id} alt="img" size={40} borderRadius={6} />
                  ) : key === "checkbox" ? (
                    <img
                      src={
                        value
                          ? theme === "light"
                            ? icons.check_in
                            : icons.check_in_dark
                          : theme === "light"
                            ? icons.check_out
                            : icons.check_out_dark
                      }
                      alt="check"
                      onClick={(e) => {
                        e.stopPropagation();
                        onCheckboxClick(!value);
                      }}
                      className="pointer"
                    />
                  ) : key === "entitet" &&
                    rowData.className === "registered-user" ? (
                    <div className="flex-direction-column width-100 entity-position-cell">
                      <ExpandableText
                        text={String(value)}
                        isLoadingData={isLoadingData}
                        isPlaceholder={isPlaceholder}
                        className={rowData.className + " " + key}
                        query={query}
                      />
                      {rowData.pozicijaSub && (
                        <ExpandableText
                          text={String(rowData.pozicijaSub)}
                          isLoadingData={isLoadingData}
                          isPlaceholder={isPlaceholder}
                          className={rowData.className + " pozicija-sub"}
                          query={query}
                        />
                      )}
                    </div>
                  ) : key === "datum_prijave" ? (
                    <p className="font-12 inria-sans-400 submission-date-cell">
                      {value ? (
                        <>
                          {formatDate(value)}
                          <span className="submission-date-time">
                            {timeString(value)}
                          </span>
                        </>
                      ) : (
                        "—"
                      )}
                    </p>
                  ) : key === "drzavljanstvo" ? (
                    <CountryFlag
                      flag={rowData.drzavljanstvoFlag}
                      name={String(value)}
                    />
                  ) : key === "predlozi" && rowData?.predlozi ? (
                    <Suggestions
                      value={value}
                      rowData={rowData}
                      suggestions={suggestions}
                      counters={counters}
                      t={t}
                      verifiers={verifiers}
                    />
                  ) : key === "status" ? (
                    <ExpandableText
                      isLoadingData={isLoadingData}
                      status={true}
                      className={rowData.className + " " + key + " " + value}
                      isPlaceholder={isPlaceholder}
                      query={query}
                      text={String(status)}
                      onStatusClick={(e) => {
                        e.stopPropagation();
                        onStatusClick(rowData.id, value);
                      }}
                      showSaveButton={showSaveButton}
                    />
                  ) : (key === "naziv" &&
                      rowData.className === "event-groups-table") ||
                    (key === "celo_ime" &&
                      rowData.className === "event-users-table") ? (
                    <ExpandableText
                      text={key !== "status" ? String(value) : String(status)}
                      isLoadingData={isLoadingData}
                      isPlaceholder={isPlaceholder}
                      className={rowData.className + " " + key}
                      query={query}
                      status={key === "status"}
                      onClick={(e) => {
                        e.stopPropagation();
                        onNameClick(rowData.id);
                      }}
                    />
                  ) : (
                    <React.Fragment>
                      {key === "skracenica" &&
                        rowData.children &&
                        rowData.children.length > 0 && (
                          <img
                            src={icons.arrow}
                            alt="arr_down"
                            width={24}
                            height={24}
                            className="pointer has-children-arrow"
                            onClick={(e) => {
                              e.stopPropagation();
                              setShowChildren(!showChildren);
                            }}
                            style={{
                              transform: showChildren
                                ? "rotate(90deg)"
                                : "rotate(0deg)",
                            }}
                          />
                        )}

                      <ExpandableText
                        text={key !== "status" ? String(value) : String(status)}
                        isLoadingData={isLoadingData}
                        isPlaceholder={isPlaceholder}
                        className={rowData.className + " " + key}
                        query={query}
                        status={key === "status"}
                        hasChildren={
                          key === "skracenica" &&
                          rowData.children &&
                          rowData.children.length
                        }
                      />
                    </React.Fragment>
                  )}
                  {key === "ime" &&
                    rowData.className === "registered-user" &&
                    rowData.unreadKomentariCount > 0 && (
                      <span
                        className="unread-komentari-badge"
                        title={t("UNREAD_COMMENTS") || "Unread comments"}
                      >
                        {rowData.unreadKomentariCount > 99
                          ? "99+"
                          : rowData.unreadKomentariCount}
                      </span>
                    )}
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
      {rowData.children && showChildren && (
        <div className="width-100">
          {Array.isArray(rowData.children) &&
            rowData.children.map((child, index) => (
              <ChildrenRow
                key={child.id ?? index}
                totalWidth={totalWidth}
                seeAllColumns={seeAllColumns}
                onNameClick={onNameClick}
                rowData={{
                  id: child.id,
                  skracenica: child.skracenica,
                  naziv: child.naziv,
                  opis: child.opis,
                  actions_3: "",
                  width: rowData.width,
                  className: rowData.className,
                  missingTemplate:
                    !child.hasDizajnTemplate && !child.dizajnTemplate && !child.parentDizajn,
                }}
                isLoadingData={isLoadingData}
                isPlaceholder={isPlaceholder}
                query={query}
                onClick={onClick}
              />
            ))}
        </div>
      )}
    </React.Fragment>
  );
};

export default TableRow;
